import React from 'react';
import { motion } from 'framer-motion';
import './SocialProofSection.css';

const SocialProofSection = () => {
  const testimonials = [
    {
      quote: "The new version of charts have lots of stuff to unearth. For those who like to play with data it’s like kid in a candy store.",
      author: "Mohit"
    },
    {
      quote: "I am an annual subscriber, have seen these charts help my trading over the past year and half. There is so much more clarity today.",
      author: "Shrinivas"
    },
    {
      quote: "I have subscribed for order flow course and now I'm using order flow charts on Vtrender™. It has been really helpful for me thanks alot.",
      author: "Raghu"
    },
    {
      quote: "Market speaks through data and that data is best at Vtrender™.",
      author: "Aditya"
    }
  ];

  return (
    <section className="social-proof-section" id="social-proof">
      {/* Gradient background elements */}
      <div className="glow-orb left"></div>
      <div className="glow-orb right"></div>
      
      {/* Star field background */}
      <div className="star-field">
        {[...Array(30)].map((_, i) => {
          const size = Math.random() > 0.8 ? 'star-lg' : Math.random() > 0.5 ? 'star-md' : 'star-sm';
          const style = {
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animationDuration: `${Math.random() * 3 + 2}s`,
            animationDelay: `${Math.random() * 2}s`
          };
          return <div key={i} className={`star ${size}`} style={style}></div>;
        })}  
      </div>
      
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Trusted by India's Most Disciplined Derivatives Traders</h2>
          <p>See what our community has to say about their experience</p>
        </motion.div>
        
        <div className="testimonials-container">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <div className="quote-mark">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 11H6C5.46957 11 4.96086 10.7893 4.58579 10.4142C4.21071 10.0391 4 9.53043 4 9V7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H8C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7V15C10 16.0609 9.57857 17.0783 8.82843 17.8284C8.07828 18.5786 7.06087 19 6 19H5" stroke="#3A86FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20 11H16C15.4696 11 14.9609 10.7893 14.5858 10.4142C14.2107 10.0391 14 9.53043 14 9V7C14 6.46957 14.2107 5.96086 14.5858 5.58579C14.9609 5.21071 15.4696 5 16 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V15C20 16.0609 19.5786 17.0783 18.8284 17.8284C18.0783 18.5786 17.0609 19 16 19H15" stroke="#3A86FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p className="testimonial-quote">{testimonial.quote}</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
